module.exports = __webpack_public_path__ + "fonts/effect-student-loans-c44a62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-student-loans.svg
// module id = 834
// module chunks = 0